window.listCssVariables = function(filter) {
  const defaultFilters = ['--footer', '--navbar', '--theme'];
  const seen = new Set();
  const results = [];

  for (const sheet of document.styleSheets) {
    let rules;
    try {
      rules = sheet.cssRules;
    } catch (e) {
      continue; // skip cross-origin
    }

    for (const rule of rules) {
      if (rule.type === CSSRule.STYLE_RULE && rule.style) {
        for (const name of rule.style) {
          if (!name.startsWith('--')) continue;

          const shouldInclude = Array.isArray(filter)
            ? filter.some(f => name.includes(f))
            : (filter
                ? name.includes(filter)
                : defaultFilters.some(f => name.includes(f)));

          if (!shouldInclude || seen.has(name)) continue;

          const computedValue = getComputedStyle(document.documentElement)
            .getPropertyValue(name)
            .trim();

          if (computedValue) {
            results.push({
              variable: name,
              value: computedValue,
              //selector: ':computed'
            });
            seen.add(name);
          }
        }
      }
    }
  }

  results.sort((a, b) => a.variable.localeCompare(b.variable));
  console.table(results);
  return results;
};
